module.exports = __webpack_public_path__ + "static/media/presentation.8042da49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/presentation.png
// module id = 5826
// module chunks = 0